import { createApiClient } from '../../shared/http/createApiClient.js';

const client = createApiClient({ auth: true });

export const exportApi = {
  // Every base table in the backend's own database, with approximate row counts.
  listTables: () => client.get('/sql-tool/export/tables'),

  // tables: [{ schema, name, include_data }]. POST (not GET) because the list can
  // be longer than a URL. Resolves to { blob, headers }.
  run: (tables) => client.downloadPost('/sql-tool/export', { tables }),
};
